import Swagger from 'swagger-client'
import { API_URL, SRPRS_DEV } from '../env'
import { store } from '../store/store'
import { setLoginTokens } from './models/member'

let client: any

export function userFetch(
  url: string,
  options: any = { headers: {} },
): Promise<any> {
  options.headers['Accept-Language'] = store.getState().locale.language

  return fetch(url, options)
}

export function getClient(auth?: boolean): Promise<any> {
  return new Promise(async (resolve, reject) => {
    const state = store.getState()
    const auths: { Member?: string } = {}

    if (auth && state.member.token) {
      if (+new Date() >= +new Date(state.member.expires)) {
        const response = await fetch(`${API_URL}/members/refresh/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            token: state.member.refresh_token,
          }),
        })
        const data = await response.json()
        auths.Member = 'Member ' + data.token
        store.dispatch(
          setLoginTokens(data.token, data.refresh_token, data.expires),
        )
      } else {
        auths.Member = 'Member ' + state.member.token
      }
    }

    if (client) {
      client.authorizations = auths
      resolve(client)
    } else {
      Swagger(`${API_URL}/swagger.json`, { authorizations: auths, userFetch })
        .then((theClient: any) => {
          client = theClient // Cache client so schema is only fetched once
          resolve(theClient)
        })
        .catch(reject)
    }
  }).then(() => {
    // Keyed off the API origin, not the build profile: any non-production
    // API host needs the swagger client re-pointed at API_URL.
    if (SRPRS_DEV) {
      const { host, protocol, pathname } = new URL(API_URL)
      client.spec = client.spec || {}
      client.spec.host = (host + pathname).replace(/\/$/, '')
      client.spec.schemes = client.spec.schemes || []
      client.spec.schemes[0] = protocol.slice(0, -1)
    }
    return client
  })
}
